/**
 * Admin user management API calls.
 */
import api from "@/utils/axios";
import type { AdminUserOverview, AdminUserUpdatePayload } from "@/types/adminUser.types";

export const fetchAdminUsers = async (): Promise<AdminUserOverview[]> => {
  const response = await api.get<AdminUserOverview[]>("/admin/users");
  return response.data;
};

export const makeUserAdmin = async (userId: string): Promise<void> => {
  await api.patch(`/admin/users/${encodeURIComponent(userId)}/admin`);
};

export const setUserBlocked = async (
  userId: string,
  blocked: boolean
): Promise<void> => {
  await api.patch(`/admin/users/${encodeURIComponent(userId)}/block`, {
    blocked,
  });
};

export const updateUser = async (
  userId: string,
  payload: AdminUserUpdatePayload
): Promise<void> => {
  await api.put(`/admin/users/${encodeURIComponent(userId)}`, payload);
};

export const deleteUser = async (userId: string): Promise<void> => {
  await api.delete(`/admin/users/${encodeURIComponent(userId)}`);
};

/**
 * Sends an invite email that links to registration.
 */
export const inviteUser = async (
  email: string,
  english: boolean
): Promise<void> => {
  await api.post("/admin/users/invite", { email, english });
};
